import { render, staticRenderFns } from "./ServicesSection.vue?vue&type=template&id=7a279961&scoped=true&lang=html&"
import script from "./ServicesSection.vue?vue&type=script&lang=js&"
export * from "./ServicesSection.vue?vue&type=script&lang=js&"
import style0 from "./ServicesSection.vue?vue&type=style&index=0&id=7a279961&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a279961",
  null
  
)

export default component.exports